<template>
  <LexicalComposer :initial-config="initialConfig">
    <div
      class="editor-shell h-full rounded-md border dark:border-surface-700 grid"
      :class="[
        hideToolbar ? 'grid-rows-1' : 'grid-rows-[auto_1fr]',
        disabled ? 'pointer-events-none cursor-not-allowed' : 'pointer-events-auto',
      ]"
      v-bind="$attrs"
    >
      <Editor v-model="markdown" :hide-toolbar="hideToolbar" />
    </div>
  </LexicalComposer>
</template>

<script setup lang="ts">
// Most of the setup is from: https://github.com/wobsoriano/lexical-vue/tree/main/playground

import type { InitialConfigType } from "lexical-vue";
import { LexicalComposer } from "lexical-vue";
import Editor from "./EditorInner.vue";
import PlaygroundEditorTheme from "./theme/PlaygroundEditorTheme";
import PlaygroundNodes from "./nodes/PlaygroundNodes";
import { $convertFromMarkdownString, TRANSFORMERS } from "@lexical/markdown";
import { IMAGE_TRANSFORMER } from "./transformers/image";

const props = defineProps<{
  initialData?: string;
  hideToolbar?: boolean;
  disabled?: boolean;
}>();

const markdown = defineModel<string>({
  default: "",
});

const initialConfig: InitialConfigType = {
  namespace: "Playground",
  theme: PlaygroundEditorTheme,
  nodes: [...PlaygroundNodes],
  editable: true,
  editorState: () => {
    return $convertFromMarkdownString(
      props.initialData || "",
      [IMAGE_TRANSFORMER, ...TRANSFORMERS],
      undefined,
      true
    );
  },
  onError,
};

function onError(error: Error) {
  console.error("Lexical error", error);
}

onBeforeMount(() => {
  if (props.initialData) {
    markdown.value = props.initialData;
  }
});
</script>
